'use strict';

angular.module('intranetApp', [
    // Vendor Dependencies
    'ngResource',
    'ngRoute',
    'ui.bootstrap',
    'ngCookies',
    'angularUtils.directives.dirPagination',
    'ngFileUpload',
    'flow',
    'agGrid',
    'ngResize',
    // Modules
    'pi.module.announcements',
    'pi.module.documents',
    'pi.module.calendar'
]);
//# sourceMappingURL=app.js.map
